import { Controller } from '@hotwired/stimulus';
import Rails from '@rails/ujs';

export default class extends Controller {
  new(event) {
    this.request({
      url: event.params.url,
      type: 'get',
      success: (data) => {
        this.handleNewResponse(data.html);
      }
    });
  }

  newSubUnit(event) {
    const form = event.target.closest('form');
    this.request({
      url: event.params.url,
      type: 'get',
      success: (data) => {
        this.handleSaveResponse(form, data.html, true);
      }
    });
  }

  create(event) {
    const form = event.target.closest('form');
    this.request({
      url: `${event.params.url || form.action}?parent_unit_id=${event.params.parentId}`,
      data: `${event.target.name}=${encodeURIComponent(event.target.value)}`,
      type: 'post',
      success: (data) => {
        this.handleSaveResponse(form, data.html);
      }
    });
  }

  update(event) {
    const form = event.target.closest('form');
    this.request({
      url: `${form.action}?parent_unit_id=${event.params.parentId}&subunit_id=${event.params.subunitId}`,
      data: `${event.target.name}=${encodeURIComponent(event.target.value)}`,
      type: 'put',
      success: (data) => {
        this.handleSaveResponse(form, data.html);
      }
    });
  }

  // remove an input that hasn't been saved yet
  remove(event) {
    const form = event.target.closest('.unit-subform');
    // someone immediately clicked the remove button after entering text
    if (form.querySelector('input[type=text]').value != '') {
      return;
    }
    form.remove();
  }

  destroy(event) {
    const form = event.target.closest('form');
    this.request({
      url: `${form.action}?sub_unit_id=${event.params.subUnitId}`,
      type: 'delete',
      success: (data) => {
        this.handleSaveResponse(form, data.html);
      }
    });
  }

  // private

  request(options) {
    Rails.ajax({
      url: options.url,
      type: options.type,
      data: options.data,
      dataType: 'json',
      success: options.success
    });
  }

  handleNewResponse(html) {
    this.element.insertAdjacentHTML('beforeend', html);
    const inputs = this.element.querySelectorAll('input');
    inputs[inputs.length - 1].focus();
  }

  handleSaveResponse(formElement, html, focus = false) {
    // Don't try to render update if DOM has changed.
    if (formElement.parentNode != null) {
      const parent = formElement.parentNode;
      formElement.outerHTML = html;

      if (focus) {
        parent.querySelectorAll('input').forEach((input) => {
          if (input.value == '') {
            input.focus();
            return;
          }
        });
      }
    }
  }
}
